module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-meet-dr"
  }, [_c('div', {
    staticClass: "custom-meet-dr__background"
  }, [_c('div', {
    staticClass: "custom-meet-dr__container"
  }, [_c('Title', {
    attrs: {
      "props": _vm.props.meet_title
    }
  }), _c('div', {
    staticClass: "custom-meet-dr__row-middle"
  }, [_c('v-waypoint', {
    staticClass: "custom-meet-dr__waypoint",
    on: {
      "waypoint-in": function($event) {
        _vm.fadeUp()
      }
    }
  }), _c('div', {
    ref: "img",
    staticClass: "custom-meet-dr__img"
  }, [_c('img', {
    attrs: {
      "src": _vm.props.meet_row_middle.img
    }
  })]), _c('div', {
    staticClass: "custom-meet-dr__awards",
    domProps: {
      "innerHTML": _vm._s(_vm.props.meet_row_middle.awards)
    }
  })], 1), _c('div', {
    staticClass: "custom-meet-dr__row-bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.props.meet_row_bottom)
    }
  })], 1)]), _c('div', {
    staticClass: "custom-meet-dr__background"
  }, [_c('div', {
    staticClass: "custom-meet-dr__container"
  }, [_c('Title', {
    attrs: {
      "props": _vm.props.meet_title_two
    }
  }), _c('div', {
    staticClass: "custom-meet-dr__row-middle"
  }, [_c('v-waypoint', {
    staticClass: "custom-meet-dr__waypoint-two",
    on: {
      "waypoint-in": function($event) {
        _vm.fadeUpTwo()
      }
    }
  }), _c('div', {
    ref: "img_two",
    staticClass: "custom-meet-dr__img"
  }, [_c('img', {
    attrs: {
      "src": _vm.props.meet_row_middle_two.img
    }
  })]), _c('div', {
    staticClass: "custom-meet-dr__awards",
    domProps: {
      "innerHTML": _vm._s(_vm.props.meet_row_middle_two.awards)
    }
  })], 1), (_vm.props.meet_row_bottom_two) ? _c('div', {
    staticClass: "custom-meet-dr__row-bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.props.meet_row_bottom_two)
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05e89062","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-meet-dr/custom-meet-dr.pug
// module id = 575
// module chunks = 1